import { Component, OnInit, OnChanges } from '@angular/core';
import * as jQuery from "jquery";
import { DacConfig } from 'app/shared/services/dac-config.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public title:string;

  constructor(private dacConfig:DacConfig) { 
    this.title = dacConfig.applicationTitle;
  }
 
  ngOnInit() {

    
  }
  ngAfterViewInit() {
    
  }
  ngOnDestroy() {
  }

  get supportPhone() {
    return this.dacConfig.supportPhone;
  }

  get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  get mailLink() {
    return "mailto:" + this.supportEmail;
  }
  get phoneLink() {
    return "tel:" + this.supportPhone;
  }

  get copyrightTitle() {
    return this.dacConfig.copyrightTitle;
  }
  get copyrightURL() {
    return this.dacConfig.copyrightURL;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts